module.exports = Swal;